export const DA_MAX_SIZE_DISTRICT = 50
export const DA_CITY_WITH_NULLABLE_DISTRICT = '세종특별자치시'
